import { Routes } from '@angular/router';

export const appRoutes: Routes = [
	{
		path: '',
		loadChildren: () => import('./core/routing/core-routing').then(m => m.coreRoutes),
	},
];
